// get cookie by name
export function getCookie(name) {
	const match = document.cookie
		.split('; ')
		.find(row => row.startsWith(name + '='))
	return match ? decodeURIComponent(match.split('=')[1]) : null
}

// set cookie
export function setCookie(name, value, days = 365) {
	const expires = new Date(Date.now() + days * 864e5).toUTCString()
	document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/`
}

// Expose helpers on window in development for console testing
if (process.env.NODE_ENV === 'development') {
	window.__cookies = { getCookie, setCookie }
}